import React from 'react';
import Localize from 'react-intl-universal';
import { useLocation } from 'react-router-dom';

import { BOOKING_PROCESS } from '@common/network';
import BadUrlMessage from '@components/BadUrlMessage/BadUrlMessage';
import ConfirmationPage from '@components/ConfirmationPage/ConfirmationPage';
import useConfirmation from '@hooks/Confirmation/useConfirmation';

const BookingConfirmation = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const bookingUuid = queryParams.get('booking');

  const { isLoading, open, errorMessage, confirmMessage, isInvalidUrl, approvalNeeded } =
    useConfirmation(bookingUuid, BOOKING_PROCESS.BOOKINGS_CONFIRMATION);

  if (isInvalidUrl) {
    return <BadUrlMessage />;
  }

  return (
    <ConfirmationPage
      confirmMessage={confirmMessage}
      approvalNeeded={approvalNeeded}
      errorMessage={errorMessage}
      headline1={Localize.get('Booking.confirmPage')}
      headline2={Localize.get('Booking.confirmPageQuestion')}
      headline3={Localize.get('Booking.bookingConfirmationExpired')}
      isLoading={open || isLoading}
    />
  );
};

export default BookingConfirmation;
